<mat-card class="card-style-full px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class="">Edição Administrador</mat-card-title>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>

  <div class="mt-4 mb-2"></div>
  <mat-card class="card-style px-6 pb-6">
    <div [formGroup]="formEmployee">
      <h4>Administrador</h4>

      <div>
        <div class="flex justify-between gap-4 items-center">
          <!-- Tipo de pessoa -->
          <mat-form-field class="input-tg w-4/12" appearance="outline">
            <mat-label>Tipo Pessoa</mat-label>
            <mat-select formControlName="typePerson">
              @for (item of listPessoas; track item) {
                <mat-option [value]="item.id">{{ item.descricao }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <!-- Município -->
          <mat-form-field class="input-tg w-4/12" appearance="outline">
            <mat-label>Município</mat-label>
            <mat-select formControlName="municipality" (selectionChange)="onMunicipioChange()">
              @for (type of listaMunicipios; track type) {
                <mat-option [value]="type.id">{{ type.nome }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <!-- Unidade de saúde -->
          <mat-form-field class="input-tg w-4/12" appearance="outline">
            <mat-label>Unidade de Saúde</mat-label>
            <mat-select formControlName="healthUnit">
              @for (type of listUnidades; track type) {
                <mat-option [value]="type.id">{{ type.nome }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="flex justify-between gap-4 items-center">
          <mat-form-field class="input-tg w-4/12" appearance="outline">
            <mat-label>Email - Login</mat-label>
            <input matInput formControlName="email" />
          </mat-form-field>

          <mat-form-field class="input-tg w-4/12" appearance="outline">
            <mat-label>Senha - Login</mat-label>
            <input matInput type="password" formControlName="password" />
          </mat-form-field>

          <mat-form-field class="input-tg w-4/12" appearance="outline">
            <mat-label>Telefone</mat-label>
            <input [mask]="'(99)99999-9999'" matInput formControlName="phone" />
          </mat-form-field>
        </div>

        <!-- Pessoa Física -->
        <div *ngIf="tipoPessoa === 1">
          <div class="mt-2"><mat-divider></mat-divider></div>
          <h4>Pessoa Física</h4>

          <div class="flex justify-between gap-4 items-center">
            <mat-form-field class="input-tg w-3/12" appearance="outline">
              <mat-label>Nome</mat-label>
              <input matInput formControlName="name" />
            </mat-form-field>

            <mat-form-field class="input-tg w-2/12" appearance="outline">
              <mat-label>RG</mat-label>
              <input matInput formControlName="rg" />
            </mat-form-field>

            <mat-form-field class="input-tg w-2/12" appearance="outline">
              <mat-label>CPF</mat-label>
              <input matInput formControlName="cpf" [mask]="'999.999.999-99'" />
            </mat-form-field>

            <mat-form-field class="input-tg w-2/12" appearance="outline">
              <mat-label>Gênero</mat-label>
              <mat-select formControlName="sex">
                @for (type of [{id: 'M', descricao: "Masculino"},{id: "F", descricao: "Feminino"}]; track type) {
                  <mat-option [value]="type.id">{{ type.descricao }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field class="input-tg w-2/12" appearance="outline">
              <mat-label>Data nascimento</mat-label>
              <input
                matInput
                [matDatepicker]="birth"
                (focus)="openDatepicker('birth')"
                formControlName="birth"
                [max]="maxDate"
              />
              <mat-datepicker-toggle matIconSuffix [for]="birth"></mat-datepicker-toggle>
              <mat-datepicker #birth></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="input-tg w-2/12" appearance="outline">
              <mat-label>Estado Civil</mat-label>
              <mat-select formControlName="maritalStatus">
                @for (type of [
                  { id: 1, descricao: "Solteiro(a)" },
                  { id: 2, descricao: "Casado(a)" },
                  { id: 3, descricao: "Divorciado(a)" },
                  { id: 4, descricao: "Viúvo(a)" },
                  { id: 5, descricao: "Separado(a)" },
                  { id: 6, descricao: "União Estável" }
                ]; track type) {
                  <mat-option [value]="type.id">{{ type.descricao }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <!-- Pessoa Jurídica -->
        <div *ngIf="tipoPessoa === 2">
          <div class="mt-2"><mat-divider></mat-divider></div>
          <h4>Pessoa Jurídica</h4>

          <div class="flex justify-between gap-4 items-center">
            <mat-form-field class="input-tg w-4/12" appearance="outline">
              <mat-label>Nome Fantasia</mat-label>
              <input matInput formControlName="fantasy_name" />
            </mat-form-field>

            <mat-form-field class="input-tg w-4/12" appearance="outline">
              <mat-label>Razão Social</mat-label>
              <input matInput formControlName="corporate_name" />
            </mat-form-field>

            <mat-form-field class="input-tg w-4/12" appearance="outline">
              <mat-label>CNPJ</mat-label>
              <input matInput [mask]="'99.999.999/9999-99'" formControlName="cnpj" />
            </mat-form-field>
          </div>
        </div>

        <div class="mt-2"><mat-divider></mat-divider></div>
        <h4>Endereço</h4>

        <div class="flex justify-between gap-4 items-center">
          <mat-form-field class="input-tg w-2/12" appearance="outline">
            <mat-label>CEP</mat-label>
            <input
              matInput
              (input)="getAddressByPostalCode()"
              (blur)="getAddressByPostalCode()"
              formControlName="postalCode"
            />
          </mat-form-field>

          <mat-form-field class="input-tg w-4/12" appearance="outline">
            <mat-label>Logradouro</mat-label>
            <input matInput formControlName="street" />
          </mat-form-field>

          <mat-form-field class="input-tg w-1/12" appearance="outline">
            <mat-label>Número</mat-label>
            <input matInput formControlName="number" />
          </mat-form-field>

          <mat-form-field class="input-tg w-2/12" appearance="outline">
            <mat-label>Bairro</mat-label>
            <input matInput formControlName="neighborhood" />
          </mat-form-field>

          <mat-form-field class="input-tg w-3/12" appearance="outline">
            <mat-label>Cidade</mat-label>
            <input matInput formControlName="city" />
          </mat-form-field>

          <mat-form-field class="input-tg w-3/12" appearance="outline">
            <mat-label>Estado</mat-label>
            <input [mask]="'SS'" placeholder="CE, SP" matInput formControlName="state" />
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="flex justify-end mt-3">
      <button
        mat-flat-button
        class="btn-tg w-1/5"
        [disabled]="!checkForm() || loading"
        (click)="editDriver()"
      >
        @if (loading) {
          <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
        } @else {
          Editar
        }
      </button>
    </div>
  </mat-card>
</mat-card>
